<template>
  <div class="c-job-error">
    <p>{{errorMsg}}</p>
  </div>
</template> 

<script>
export default {
  name: 'JobErrorComponent',
  props: ['errorMsg']
}
</script>


// WEBPACK FOOTER //
// src/components/components/consumer/job-tracker/JobError.vue